<template>
    <div>
        <!-- slot for parent component to activate the file changer -->
        <div @click="launchFilePicker()">
            <slot name="activator"></slot>
        </div>
        <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
        <input :disabled="!pending" type="file" ref="file" :name="uploadFieldName" @change="onFileChange(
        $event.target.name, $event.target.files)" style="display:none">
        <!-- error dialog displays any potential error messages -->
    </div>
</template>
<script>
export default {
    name: 'image-input',
    data() {
        return {
            uploadFieldName: 'file',
            maxSize: 1024
        }
    },
    props: {
        // Use "value" to enable using v-model
        value: Object,
        pending: Boolean
    },
    methods: {
        launchFilePicker() {
            this.$refs.file.click();
        },
        onFileChange(fieldName, file) {
            const { maxSize } = this
            let imageFile = file[0]
            if (file.length > 0) {
                let size = imageFile.size / maxSize / maxSize
                if (!imageFile.type.match('image.*')) {
                    // check whether the upload is an image
                    this.$toast.error('فرمت فایل انتخابی صحیح نیست.')
                } else if (size > 1) {
                    // check whether the size is greater than the size limit
                    this.$toast.error('حجم فایل انتخابی نباید بیش از ۱ مگابایت باشد.')
                } else {
                    // Append file into FormData and turn file into image URL
                    let imageURL = URL.createObjectURL(imageFile)
                    // Emit the FormData and image URL to the parent component
                    this.$emit('input', { imageFile, imageURL })
                }
            }
        }
    }
}
</script>